module.exports = __webpack_public_path__ + "img/logo.01c8a3af.jpg";